import styles from "./FeedbackFormSkeleton.module.scss"

const STEPS = [0, 1, 2, 3]
const RATINGS = [0, 1, 2, 3, 4]

export function FeedbackFormSkeleton() {
  return (
    <div
      className={styles.container}
      role="status"
      aria-label="Loading feedback form"
    >
      <div className={styles.stepper} aria-hidden="true">
        {STEPS.map((i) => (
          <span key={i} className={styles.stepperSegment} />
        ))}
      </div>
      <div className={styles.card} aria-hidden="true">
        <div className={styles.legend}>
          <span className={styles.legendLine} />
          <span className={styles.legendLineShort} />
        </div>
        <div className={styles.ratings}>
          {RATINGS.map((i) => (
            <span key={i} className={styles.ratingPill}>
              <span className={styles.ratingCircle} />
              <span className={styles.ratingNumber} />
            </span>
          ))}
        </div>
        <div className={styles.nav}>
          <span className={styles.navButton} />
          <span className={styles.navButton} />
        </div>
      </div>
    </div>
  )
}
